<script>
export default {
  name: "gallery-item",

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div @click.self="$emit('hide:item')" @contextmenu.prevent="() => {return false}" class="overlay">
    <button
      @click.prevent="$emit('hide:item')"
      href="#"
      class="btn btn-transparent close"
    >
      &times;
    </button>

    <div class="item d-grid">
      <div @contextmenu.prevent="() => {return false}" class="photo">
        <img @contextmenu.prevent="() => {return false}" :src="item.photo" />
      </div>

      <div class="text d-grid">
        <div class="item-name display-4 accent">
          <template v-if="item.suffix"
            ><span v-html="item.name" />,
            <span class="small">{{ item.suffix }}</span></template
          >
          <span v-else v-html="item.name" />
        </div>

        <audio
          v-if="item.audioFile"
          @play="$emit('audio:playing')"
          @ended="$emit('audio:stopped')"
          class="item-player"
          controls
          autoplay
          controlsList="nodownload"
          ref="itemplayer"
        >
          <source :src="item.audioFile" />
        </audio>

        <div v-html="item.text" class="item-text" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.overlay {
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  min-height: 100vh;
  width: 100vw;
  z-index: 10;

  .item {
    height: 100vh;
    width: 100vw;
    grid-template-columns: 4fr 6fr;
    grid-template-rows: 100vh;
    grid-template-areas: "text photo";
    pointer-events: none;
    align-items: center;
    justify-items: center;

    & > .photo {
      grid-area: photo;
      padding: 20px;
      max-height: 100%;

      img {
        max-height: 90vh;
        max-width: 100%;
      }
    }

    & > .text {
      grid-area: text;
      grid-template-rows: auto auto minmax(0, 500px);
      grid-template-areas:
        "name"
        "audio"
        "text";
      row-gap: 20px;
      padding: 20px;

      .item-name {
        grid-area: name;
      }

      .item-player {
        grid-area: audio;
        max-height: 30px;
        max-width: 100%;
        pointer-events: auto;
      }

      .item-text {
        grid-area: text;
        overflow: auto;
        pointer-events: auto;
      }
    }
  }

  .close {
    font-size: 3rem;
    color: rgba(255, 255, 255, 0.5);
    text-decoration: none;
    position: absolute;
    top: 0;
    right: 25px;
    transition: color 500ms;

    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }

  .display-4 {
    font-family: "DM Serif Display", serif;
  }

  &::v-deep {
    .attribution {
      padding-left: 1rem;
      font-size: 0.9rem;
    }

    .attribution::before {
      content: "\2013";
    }
  }
}
</style>